module.exports = __webpack_public_path__ + "static/img/work_done.61db6532.png";